import React from 'react';
import ReaderProfileSettings from './profile/ReaderProfileSettings';
import VendorProfileSettings from './profile/VendorProfileSettings';
import UserRoleToggle from '../components/UI/UserRoleToggle';
import { useUserRole } from '../context/UserRoleContext';
const ProfileSettings = () => {
  const {
    isReader,
    toggleUserRole
  } = useUserRole();
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-12877" data-mp="leery3vk0aum">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12878" data-mp="zbbhm1zxrm9x">
        <div className="mb-6" data-id="element-12879" data-mp="z9qomgt9sbe6">
          <div className="flex justify-between items-center" data-id="element-12880" data-mp="uds2z0zbt7hg">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-12881" data-mp="ub5umz4m2ny6">
              Profile Settings
            </h1>
            <UserRoleToggle isReader={isReader} toggleUserRole={toggleUserRole} data-id="element-12882" data-mp="142tfgh6nx6qo" />
          </div>
        </div>
        {isReader ? <ReaderProfileSettings data-id="element-12883" data-mp="1i34ck1ykfhka" /> : <VendorProfileSettings data-id="element-12884" data-mp="1i089jz7v22oz" />}
      </div>
    </div>;
};
export default ProfileSettings;